import AddToCartComponent from '../../components/AddToCart/AddToCartComponent';
import template from './ProductShowWrapperModule.html';

export default {
  template,

  components: {
    AddToCartComponent,
  },

  created() {
    this.$on('pricing-updated', (newPrice) => {
      // Notify subscribers
      this.$emit('price-updated', newPrice);
    });
  },
};
